// extracted by mini-css-extract-plugin
module.exports = {"ItemList":"RelatedBlogs_ItemList__njx8h"};